<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">Home</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      抽奖管理
      <small>设置抽奖奖品以及规则...</small>
    </h1>
    <!-- end page-header -->
    <panel title="抽奖奖品管理" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add">
          <i class="fa fa-plus"></i> 新增奖品
        </button>
      </div>
      <Table :columns="columns" :data="data">
        <template slot="type" slot-scope="{row}">
          <span v-if="row.type=='coupon'">优惠券</span>
          <span v-else-if="row.type =='integral'">积分</span>
          <span v-else-if="row.type =='cash'">现金余额</span>
          <span v-else-if="row.type =='thanks'">谢谢参与</span>
        </template>
        <template slot="awardnum" slot-scope="{row}">
          <span v-if="row.awardnum == -1">不限</span>
          <span v-else>{{row.awardnum}}</span>
        </template>
        <template slot="status" slot-scope="{row}">
          <span v-if="row.status == 0">有效</span>
          <span v-else style="color:red">无效</span>
        </template>
        <template slot="action" slot-scope="{row}">
          <button type="button" class="btn btn-theme btn-sm" @click="fn_edit(row)">修改</button>
        </template>
      </Table>
    </panel>
    <Row :gutter="12">
      <Col span="8">
        <Card :bordered="false">
          <p slot="title">抽奖规则内容</p>
          <Input type="textarea" :rows="6" v-model="lotteryinteraldesc"></Input>
          <button type="button" class="btn btn-theme btn-sm m-t-10" @click="fn_save_desc">保存</button>
        </Card>
        <Card :bordered="false" class="m-t-10">
          <p slot="title">抽奖积分消耗</p>
          <div class="widget-list widget-list-rounded m-b-30" data-id="widget">
            <a href="#" @click="fn_set()" class="widget-list-item">
              <div class="widget-list-media icon">
                <i class="fa fa-gift bg-blue text-white"></i>
              </div>
              <div class="widget-list-content">
                <h4 class="widget-list-title">抽奖1次需要积分</h4>
              </div>
              <div class="widget-list-action text-nowrap text-grey-darker">
                {{lotteryinteral}}
                <i class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"></i>
              </div>
            </a>
          </div>
        </Card>
      </Col>

      <Col span="16">
        <Card :bordered="false">
          <p slot="title">客户抽奖历史</p>
          <Table :columns="historycolumns" :data="historydata">
            <template slot="user" slot-scope="{row}">{{row.user.name}}</template>
            <template slot="logo" slot-scope="{row}">
              <img :src="row.user.portrait" style="height:50px" />
            </template>
          </Table>
          <Page
            style="margin-top:10px"
            :total="totalRows"
            :current="filterCond.page"
            :page-size="filterCond.pageNum"
            show-total
            show-elevator
            @on-change="fn_switchPage"
          />
        </Card>
      </Col>
    </Row>
    <Drawer :closable="true" title="设置" width="50" v-model="v_edit_integral">
      <Form :labelWidth="120">
        <Row :gutter="10">
          <Col span="8">
            <FormItem label="消耗积分">
              <InputNumber v-model="lotteryinteral" style="width:100%" />
            </FormItem>
          </Col>
          <Col span="4">
            <button type="button" class="btn btn-theme" @click="fn_save_lotteryintegral">保存</button>
          </Col>
        </Row>
      </Form>
    </Drawer>
    <Drawer :closable="true" title="设置" width="60" v-model="v_edit">
      <Form :labelWidth="120" :model="formData" :rules="rules" ref="formData">
        <Row :gutter="10">
          <Col span="8">
            <FormItem label="奖品类型" prop="type">
              <Select v-model="formData.type">
                <Option value="coupon" label="优惠券"></Option>
                <Option value="integral" label="积分"></Option>
                <Option value="cash" label="现金余额"></Option>
                <Option value="thanks" label="谢谢参与"></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8" v-if="formData.type=='coupon'">
            <FormItem label="优惠券">
              <Select v-model="formData.objid">
                <Option
                  :value="item.id"
                  :label="item.title"
                  v-for="(item,index) in activityList"
                  :key="index"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="奖品名称" prop="name">
              <Input v-model="formData.name" maxlength="255" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="8">
            <FormItem label="奖品金额数量">
              <InputNumber style="width:100%" v-model="formData.awardamount"></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="奖品数量">
              <InputNumber style="width:100%" v-model="formData.awardnum"></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem>
              <p style="color:red">奖品数量:-1表示不限制数量</p>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="8">
            <FormItem label="中奖几率占比">
              <InputNumber style="width:100%" :min="1" v-model="formData.scale"></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="状态">
              <Select v-model="formData.status">
                <Option :value="0" label="有效"></Option>
                <Option :value="-1" label="无效"></Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="24">
            <FormItem label="说明">
              <p>1：优惠券奖品的奖品金额数量设置无效，默认是获取一个优惠券</p>
              <p>2：中奖几率占比设置为大于0的整数,以所有的奖品的中奖几率占比累加作为总的几率和,例如总的几率占比和150,如果本中奖占比几率是10,则此奖品的抽中的几率是10/150</p>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="8">
            <FormItem label>
              <button type="button" class="btn btn-theme" @click="fn_save_lotteryaward">保存</button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Drawer>
  </div>
</template>
<script>
import {
  getLotteryAwardList,
  saveLotteryAwardData,
  getLotteryHistory
} from "@/api/lottery";
import { getEnumByCode, saveEnumData } from "@/api/config";
import { getActivityList } from "@/api/activity";
export default {
  data() {
    return {
      columns: [
        {
          title: "#",
          key: "id",
          width: 70
        },
        {
          title: "奖品类型",
          slot: "type",
          width: 100
        },
        {
          title: "名称",
          key: "name",
          width: 200
        },
        {
          title: "奖品金额(数量)",
          key: "awardamount",
          width: 200
        },
        {
          title: "奖品数量限制",
          slot: "awardnum",
          width: 100
        },
        {
          title: "中奖几率占比",
          key: "scale",
          width: 100
        },
        {
          title: "状态",
          slot: "status",
          width: 100
        },
        {
          title: "操作",
          slot: "action",
          width: 200
        }
      ],
      historycolumns: [
        {
          title: "时间",
          key: "created_at",
          width: 180
        },
        {
          title: "人员",
          slot: "user",
          width: 150
        },
        {
          title: "头像",
          slot: "logo",
          width: 150
        },
        {
          title: "名称",
          key: "remarks"
        }
      ],
      data: [],
      formData: {
        id: 0,
        type: "",
        name: "",
        objid: 0,
        awardamount: 0,
        awardnum: -1,
        scale: 1,
        status: 0
      },
      v_edit: false,
      v_edit_integral: false,
      lotteryconfig: {
        lotteryinteral: { value: "" }
      },
      lotteryinteraldesc: "",
      lotteryinteral: 0,
      rules: {
        type: [
          {
            required: true,
            message: "类型必填",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "名称必填",
            trigger: "change"
          }
        ]
      },
      activityList: [], //优惠券
      historydata: [],
      totalRows: 0,
      filterCond: {
        page: 1,
        pageNum: 10
      }
    };
  },
  mounted() {
    getLotteryAwardList({})
      .then(res => {
        this.data = res.data;
      })
      .catch(error => {
        this.$message.error(error);
      });
    getEnumByCode("lotteryinteral,lotteryinteraldesc")
      .then(res => {
        this.lotteryconfig = res.data;
        this.lotteryinteraldesc = this.lotteryconfig[
          "lotteryinteraldesc"
        ].remarks;
        this.lotteryinteral = parseInt(
          this.lotteryconfig["lotteryinteral"].value
        );
      })
      .catch(error => {
        this.$message.error(error);
      });
    getActivityList({
      page: 0,
      pageNum: 0,
      actvititytype: "coupon",
      jointype: "integral"
    })
      .then(res => {
        this.activityList = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });

    this.fn_get_lottery_history(this.filterCond);
  },
  methods: {
    fn_get_lottery_history(filterCond) {
      getLotteryHistory(filterCond)
        .then(res => {
          this.historydata = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_edit(row) {
      this.v_edit = true;
      this.formData = row;
    },
    fn_add() {
      this.v_edit = true;
    },
    fn_set() {
      this.v_edit_integral = true;
    },
    fn_save_lotteryaward() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          saveLotteryAwardData(this.formData)
            .then(res => {
              this.$Notice.success(res.data);
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_save_desc() {
      saveEnumData({
        code: "lotteryinteraldesc",
        remarks: this.lotteryinteraldesc,
        value: ""
      })
        .then(res => {
          this.$Notice.success(res.data);
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    fn_save_lotteryintegral() {
      saveEnumData({
        code: "lotteryinteral",
        remarks: "抽奖一次消耗积分",
        value: this.lotteryinteral
      })
        .then(res => {
          this.$Notice.success(res.data);
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_get_lottery_history(this.filterCond);
    }
  }
};
</script>